import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateSupplierPriceImportMutationVariables = Types.Exact<{
  input: Types.CreateSupplierPriceImportInput;
}>;


export type CreateSupplierPriceImportMutation = { __typename?: 'Mutation', createSupplierPriceImport: { __typename?: 'SupplierPriceImportPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, supplierPriceImport?: { __typename?: 'SupplierPriceImportDocument', attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null } | null } };

export type CancelSupplierPriceExtractionMutationVariables = Types.Exact<{
  input: Types.SupplierPriceImportInput;
}>;


export type CancelSupplierPriceExtractionMutation = { __typename?: 'Mutation', cancelSupplierPriceExtraction: { __typename?: 'SupplierPriceImportPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, supplierPriceImport?: { __typename?: 'SupplierPriceImportDocument', attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null } | null } };

export type DecideSupplierPriceImportRowMutationVariables = Types.Exact<{
  input: Types.DecideSupplierPriceImportRowInput;
}>;


export type DecideSupplierPriceImportRowMutation = { __typename?: 'Mutation', decideSupplierPriceImportRow: { __typename?: 'SupplierPriceImportPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, supplierPriceImport?: { __typename?: 'SupplierPriceImportDocument', attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null } | null } };

export type ReviewSupplierPriceImportRowMutationVariables = Types.Exact<{
  input: Types.ReviewSupplierPriceImportRowInput;
}>;


export type ReviewSupplierPriceImportRowMutation = { __typename?: 'Mutation', reviewSupplierPriceImportRow: { __typename?: 'SupplierPriceImportPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, supplierPriceImport?: { __typename?: 'SupplierPriceImportDocument', attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null } | null } };

export type SelectSupplierPriceImportRowMutationVariables = Types.Exact<{
  input: Types.SelectSupplierPriceImportRowInput;
}>;


export type SelectSupplierPriceImportRowMutation = { __typename?: 'Mutation', selectSupplierPriceImportRow: { __typename?: 'SupplierPriceImportPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, supplierPriceImport?: { __typename?: 'SupplierPriceImportDocument', attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null } | null } };

export type CancelSupplierPriceImportApprovalMutationVariables = Types.Exact<{
  input: Types.CancelSupplierPriceImportApprovalInput;
}>;


export type CancelSupplierPriceImportApprovalMutation = { __typename?: 'Mutation', cancelSupplierPriceImportApproval: { __typename?: 'SupplierPriceImportPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, supplierPriceImport?: { __typename?: 'SupplierPriceImportDocument', attempt: number, extractedRowCount: number, extractionMessage: string, extractionRetryable: boolean, extractionState: Types.SupplierPriceImportExtractionState, importId: string, publishedExtractionRevision: number, purchasingVendorId: string, reviewRevision: number, status: Types.SupplierPriceImportStatus, source?: { __typename?: 'SupplierPriceImportSourceData', fileName: string, manufacturerName: string, pageCount: number } | null } | null } };

export type ApplySupplierPriceImportMutationVariables = Types.Exact<{
  input: Types.ApplySupplierPriceImportInput;
}>;


export type ApplySupplierPriceImportMutation = { __typename?: 'Mutation', applySupplierPriceImport: { __typename?: 'ApplySupplierPriceImportPayload', apply?: { __typename?: 'SupplierPriceImportApply', approvalState: Types.SupplierPriceImportApprovalState, stepsRemain: boolean, rows: Array<{ __typename?: 'SupplierPriceImportApplyRow', changesCurrentCosting?: boolean | null, createdMaterial: boolean, disposition: Types.SupplierPriceRowDisposition, knownSubtotalPerEach?: string | null, materialItemId?: string | null, royaltyStatus?: Types.SupplierRoyaltyStatus | null, sourceRowId: string, status: Types.SupplierPriceImportApplyRowStatus, write?: Types.MaterialPriceOperationKind | null }>, stop?: { __typename?: 'SupplierPriceImportApplyStop', message: string, result: Types.SupplierPriceImportApplyStepResult, sourceRowIds: Array<string> } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DiscardSupplierPriceImportMutationVariables = Types.Exact<{
  input: Types.SupplierPriceImportInput;
}>;


export type DiscardSupplierPriceImportMutation = { __typename?: 'Mutation', discardSupplierPriceImport: { __typename?: 'SupplierPriceImportPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateSupplierPriceImportDocument = new TypedDocumentString(`
    mutation CreateSupplierPriceImport($input: CreateSupplierPriceImportInput!) {
  createSupplierPriceImport(input: $input) {
    errors {
      code
      message
    }
    supplierPriceImport {
      ...SupplierPriceImportWorkspace
    }
  }
}
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}`);
export const CancelSupplierPriceExtractionDocument = new TypedDocumentString(`
    mutation CancelSupplierPriceExtraction($input: SupplierPriceImportInput!) {
  cancelSupplierPriceExtraction(input: $input) {
    errors {
      code
      message
    }
    supplierPriceImport {
      ...SupplierPriceImportWorkspace
    }
  }
}
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}`);
export const DecideSupplierPriceImportRowDocument = new TypedDocumentString(`
    mutation DecideSupplierPriceImportRow($input: DecideSupplierPriceImportRowInput!) {
  decideSupplierPriceImportRow(input: $input) {
    errors {
      code
      message
    }
    supplierPriceImport {
      ...SupplierPriceImportWorkspace
    }
  }
}
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}`);
export const ReviewSupplierPriceImportRowDocument = new TypedDocumentString(`
    mutation ReviewSupplierPriceImportRow($input: ReviewSupplierPriceImportRowInput!) {
  reviewSupplierPriceImportRow(input: $input) {
    errors {
      code
      message
    }
    supplierPriceImport {
      ...SupplierPriceImportWorkspace
    }
  }
}
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}`);
export const SelectSupplierPriceImportRowDocument = new TypedDocumentString(`
    mutation SelectSupplierPriceImportRow($input: SelectSupplierPriceImportRowInput!) {
  selectSupplierPriceImportRow(input: $input) {
    errors {
      code
      message
    }
    supplierPriceImport {
      ...SupplierPriceImportWorkspace
    }
  }
}
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}`);
export const CancelSupplierPriceImportApprovalDocument = new TypedDocumentString(`
    mutation CancelSupplierPriceImportApproval($input: CancelSupplierPriceImportApprovalInput!) {
  cancelSupplierPriceImportApproval(input: $input) {
    errors {
      code
      message
    }
    supplierPriceImport {
      ...SupplierPriceImportWorkspace
    }
  }
}
    fragment SupplierPriceImportWorkspace on SupplierPriceImportDocument {
  attempt
  extractedRowCount
  extractionMessage
  extractionRetryable
  extractionState
  importId
  publishedExtractionRevision
  purchasingVendorId
  reviewRevision
  source {
    fileName
    manufacturerName
    pageCount
  }
  status
}`);
export const ApplySupplierPriceImportDocument = new TypedDocumentString(`
    mutation ApplySupplierPriceImport($input: ApplySupplierPriceImportInput!) {
  applySupplierPriceImport(input: $input) {
    apply {
      ...SupplierPriceImportApply
    }
    errors {
      code
      message
    }
  }
}
    fragment SupplierPriceImportApply on SupplierPriceImportApply {
  approvalState
  rows {
    changesCurrentCosting
    createdMaterial
    disposition
    knownSubtotalPerEach
    materialItemId
    royaltyStatus
    sourceRowId
    status
    write
  }
  stepsRemain
  stop {
    message
    result
    sourceRowIds
  }
}`);
export const DiscardSupplierPriceImportDocument = new TypedDocumentString(`
    mutation DiscardSupplierPriceImport($input: SupplierPriceImportInput!) {
  discardSupplierPriceImport(input: $input) {
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateSupplierPriceImport: build.mutation<CreateSupplierPriceImportMutation, CreateSupplierPriceImportMutationVariables>({
      query: (variables) => ({ document: CreateSupplierPriceImportDocument, variables })
    }),
    CancelSupplierPriceExtraction: build.mutation<CancelSupplierPriceExtractionMutation, CancelSupplierPriceExtractionMutationVariables>({
      query: (variables) => ({ document: CancelSupplierPriceExtractionDocument, variables })
    }),
    DecideSupplierPriceImportRow: build.mutation<DecideSupplierPriceImportRowMutation, DecideSupplierPriceImportRowMutationVariables>({
      query: (variables) => ({ document: DecideSupplierPriceImportRowDocument, variables })
    }),
    ReviewSupplierPriceImportRow: build.mutation<ReviewSupplierPriceImportRowMutation, ReviewSupplierPriceImportRowMutationVariables>({
      query: (variables) => ({ document: ReviewSupplierPriceImportRowDocument, variables })
    }),
    SelectSupplierPriceImportRow: build.mutation<SelectSupplierPriceImportRowMutation, SelectSupplierPriceImportRowMutationVariables>({
      query: (variables) => ({ document: SelectSupplierPriceImportRowDocument, variables })
    }),
    CancelSupplierPriceImportApproval: build.mutation<CancelSupplierPriceImportApprovalMutation, CancelSupplierPriceImportApprovalMutationVariables>({
      query: (variables) => ({ document: CancelSupplierPriceImportApprovalDocument, variables })
    }),
    ApplySupplierPriceImport: build.mutation<ApplySupplierPriceImportMutation, ApplySupplierPriceImportMutationVariables>({
      query: (variables) => ({ document: ApplySupplierPriceImportDocument, variables })
    }),
    DiscardSupplierPriceImport: build.mutation<DiscardSupplierPriceImportMutation, DiscardSupplierPriceImportMutationVariables>({
      query: (variables) => ({ document: DiscardSupplierPriceImportDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateSupplierPriceImportMutation, useCancelSupplierPriceExtractionMutation, useDecideSupplierPriceImportRowMutation, useReviewSupplierPriceImportRowMutation, useSelectSupplierPriceImportRowMutation, useCancelSupplierPriceImportApprovalMutation, useApplySupplierPriceImportMutation, useDiscardSupplierPriceImportMutation } = injectedRtkApi;
